import LocaleMessage from './LocaleMessage';

export default LocaleMessage;
